import type { AmplitudeSessionReplayType } from './types.tsx';

const emptyAmplitudeSessionReplay: AmplitudeSessionReplayType = {
	init: () => Promise.resolve(),
	stop: () => Promise.resolve(),
};

export default emptyAmplitudeSessionReplay;
